import { Injectable } from '@angular/core';

import { OddsConfig } from '@frontend/sports/common/client-config-data-access';
import { TrackData, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';
import { OddsAcceptance } from '@frontend/sports/types/betslip/request';
import { IUserRootState, SyncUserSettingsService, UserService } from '@frontend/sports/user/feature';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';

import { OddsPreferencePopupActions } from './actions';

@Injectable({ providedIn: 'root' })
export class OddsPreferencePopupService {
    private initialPlaceBetFailureTreshold: number;
    private placeBetFailureTreshold: number;
    private minTresholdValue = 1;
    private updateFail = new Subject();
    revertOnFail$ = this.updateFail.asObservable();

    constructor(
        private oddsConfig: OddsConfig,
        private userService: UserService,
        private trackingService: TrackingService,
        private store: Store<IUserRootState>,
        private userSettings: SyncUserSettingsService,
    ) {}

    track(trackingInfo: TrackData, args: any[] = []) {
        for (const arg of args) {
            (trackingInfo[trackingConstants.PAGE_NAME as keyof TrackData] as string) += `/${arg}`;
        }

        this.trackingService.track(trackingConstants.EVENT_PAGE_VIEW, trackingInfo);
    }

    private isOddsPreferenceDisabled(): boolean {
        return !this.oddsConfig.preferencesReminder.isEnabled || this.userSettings.bettingSettings.oddsAcceptanceMode === OddsAcceptance.Any;
    }

    disable() {
        this.store.dispatch(OddsPreferencePopupActions.setDisabled({ disabled: true }));
    }

    initializeService(): boolean {
        this.placeBetFailureTreshold = Math.max(this.oddsConfig.preferencesReminder.placeBetFailureTreshold, this.minTresholdValue);
        this.initialPlaceBetFailureTreshold = Math.max(this.oddsConfig.preferencesReminder.initialPlaceBetFailureTreshold, this.minTresholdValue);

        const disabled = this.isOddsPreferenceDisabled();

        this.store.dispatch(OddsPreferencePopupActions.initializeState({ disabled }));

        return disabled;
    }

    shouldShowReminder(disabled: boolean, counter: number): boolean {
        if (disabled || counter === 0) {
            return false;
        }
        if (!this.userService.isAuthenticated) {
            return false;
        }

        if (counter === this.initialPlaceBetFailureTreshold) {
            return true;
        }

        return (counter - this.initialPlaceBetFailureTreshold) % this.placeBetFailureTreshold === 0;
    }

    propagateError() {
        this.updateFail.next(true);
    }
}
